export const MODALS_MAP = {
    'ads-form': 'adsFormModal',
};
